import api from "./api";

// 登录
const login = (params : any) => {
	api.request({
		url: '/admin/login',
		method: "POST",
		isLoading: params.isLoading ? '登录中...' : '',
		data: params.data,
		success: (res : any) => {
			localStorage.setItem("token", res.data.token);
			params.success && typeof params.success === 'function' && params.success(res.data);
		},
		fail: (err : any) => {
			params.fail && typeof params.fail === 'function' && params.fail(err);
		}
	});
};

export default {
	login: login,
}